import React from 'react';
import '@/styles/goods-collect.scss';
import Tab from 'partials/goods-collect/tab/Tab.jsx';
import {inject, observer} from 'mobx-react';
import {useCallback} from 'react';
import {useEffect} from 'react';
import {SwipeAction} from 'antd-mobile';
import showPrice from 'utils/show-price';
import {useHistory} from 'react-router-dom';
import useMyStores from "hooks/useMyStores";
import {getGoodsType} from "utils/GoodsTypeUtil";
import MyRouterUtil from "../../utils/MyRouterUtil";

const GoodsCollect = props => {
    const {goodsCollect: store} = useMyStores()
    const {list, pageSize, pageNum, order, sortField} = store;
    let history = useHistory();


    /**
     * 初始化推荐列表
     */
    useEffect(() => {
        store.fetchRecommendList();
    }, []);

    /**
     * 初始化列表
     */
    const fetchList = useCallback(() => {
        store.fetchList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pageSize, pageNum, order, sortField]);
    useEffect(() => {
        fetchList();
    }, [fetchList]);


    const toGoodsInfo = ({goodsType, id}) => {
        MyRouterUtil.build({history})
            .toGoodsInfo({goodsType, id})
    }

    function renderGoodsList() {
        return store.list.map((item, i) => {
            const {
                id,
                time,
                timeStamp,
                fid,
                type,
                name,
                mainPic,
                currentPrice,
                originPrice,
                categoryId,
                soldNum,
                pddShop,
                isPddShop,
                isJdShop,
                top
            } = item;

            const goodsType = getGoodsType({isPddShop, isJdShop});

            return (
                <SwipeAction
                    key={id}
                    className='goods-wrapper'
                    autoClose
                    right={[
                        {
                            text: '取消',
                            onPress: () => store.doDelete(id),
                            style: {
                                backgroundColor: 'rgba(240, 55, 81, 1)',
                                color: 'rgba(255, 255, 255, 1)',
                                width: '2.4rem'
                            }
                        }
                    ]}
                >
                    <div
                        className='goods'
                        onClick={() => {
                            toGoodsInfo({id, goodsType});
                        }}
                    >
                        <div className='img-block'>
                            <img src={mainPic} alt='' className='img'/>
                        </div>
                        <div className='info-block'>
                            <div className='name'>{name}</div>
                            <div className='current-price'>{showPrice(currentPrice)}</div>
                        </div>
                    </div>
                </SwipeAction>
            );
        });
    }

    function renderRecommendList() {
        return store.recommendListStore.list.map((item, i) => {
            let {
                id,
                name,
                originPrice,
                currentPrice,
                shopId,
                soldNum,
                mainPic,
                hasCollect,
                collectId,
                categoryId,
                isHot,
                isNew,
                isSpecialPrice,
                serviceTags,
                mallName,
                pddShop,
                isPddShop,
                isJdShop
            } = item;

            const goodsType = getGoodsType({isPddShop, isJdShop});

            return (
                <div
                    className='item'
                    key={id}
                    onClick={() => {
                        toGoodsInfo({id, goodsType});
                    }}
                >
                    <div className='img-block'>
                        <img src={mainPic} alt='' className='img'/>
                    </div>
                    <div className='info-block'>
                        <div className='name'>{name}</div>
                        <div className='price-floor'>
                            <div className='current-price'>{showPrice(currentPrice)}</div>
                            {!pddShop && <div className='self'>自营</div>}
                            {isHot === 1 && <div className='hot'>热卖</div>}
                        </div>
                    </div>
                </div>
            );
        });
    }

    return (
        <div className='goods-collect'>
            <Tab
                {...{
                    currentIndex: 0,
                    store
                }}
            />
            <div className='goods-list'>{renderGoodsList()}</div>
            <div className='recommend-list'>
                <div className='title-floor'>
                    <div className='title-floor'>为你推荐</div>
                </div>
                <div className='list'>{renderRecommendList()}</div>
            </div>
        </div>
    );
};

export default observer(GoodsCollect);
